export default __webpack_public_path__ + "static/The Home_Image 4_carousel 3@2x-acdd3877d8723bbf789fc36e78b0cd2a.jpg";